export function slug(name) {
    return (name ?? '').toLowerCase().replace(/[^a-z0-9]/g, '');
}
const BRANDING = {
    gastrosync: {
        slug: 'gastrosync',
        displayName: 'GastroSync',
        logo: {
            light: '/branding/gastrosync/logo-light.png',
            dark: '/branding/gastrosync/logo-dark.png',
            lightShort: '/branding/gastrosync/logo-light-short.png',
            darkShort: '/branding/gastrosync/logo-dark-short.png',
        },
        colors: {
            primary: '#2F75AE',
            primaryDark: '#3C96DF', /* dark-theme lift, mirrors plum-700→plum-400 */
            secondary: '#04A7F1',
            secondaryDark: '#1DB1F3',
        },
    },
};
export function getReseller(name) {
    const key = slug(name);
    return key && BRANDING[key] ? BRANDING[key] : null;
}
//# sourceMappingURL=registry.js.map